import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Legal.css';

function Dpa() {
  const { t } = useTranslation();
  const points = [
    'Tus datos se procesan conforme al RGPD y la LOPDGDD.',
    'Solo personal autorizado accede a tu informacion.',
    'Tus datos solo se comparten con terceros cuando es necesario para tramitar tu solicitud y siempre con tu conocimiento previo.',
    'Conservamos tus datos durante tu caso y los plazos legales.',
    'Derechos: acceso, rectificacion, supresion, portabilidad.',
    'Contacto: legal@globalmobility.law.',
  ];

  return (
    <div className="mvp-legal-page">
      <div className="mvp-legal-card">
        <h1>{t('legal.dpa', 'Data Processing Agreement')}</h1>
        <p className="mvp-legal-placeholder">
          Asi tratamos tus datos personales conforme a la normativa vigente:
        </p>
        <ul className="mvp-legal-placeholder">
          {points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        <p className="mvp-legal-placeholder">
          <a href="https://globalmobility.law/politica-privacidad" target="_blank" rel="noopener noreferrer">
            Ver documento completo
          </a>
        </p>
        <Link to="/" className="mvp-legal-back">{t('legal.goHome', 'Go to home')}</Link>
      </div>
    </div>
  );
}

export default Dpa;
